// R-Codes begin with R and include a number; this avoids misrouting project-name searches.
// Examples: R07150B, R-1234, RML-001
export const isRCodePattern = (query: string): boolean => {
  // Search only complete codes to avoid broad relationship queries while typing.
  return /^(?:R\d{4,}[A-Z]?|R[A-Z]+-\d{3,})$/i.test(query.trim());
};
